var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.3 11.8395L25.8 2.80759C25.2486 2.50411 24.6294 2.34497 24 2.34497C23.3706 2.34497 22.7514 2.50411 22.2 2.80759L5.7 11.8395C5.10959 12.1625 4.61701 12.6385 4.27391 13.2175C3.93081 13.7964 3.74984 14.4571 3.75 15.1301V33.0588C3.74984 33.7318 3.93081 34.3925 4.27391 34.9715C4.61701 35.5504 5.10959 36.0264 5.7 36.3495L22.2 45.3813C22.7513 45.6852 23.3705 45.8445 24 45.8445C24.6295 45.8445 25.2487 45.6852 25.8 45.3813L42.3 36.3495C42.8904 36.0264 43.383 35.5504 43.7261 34.9715C44.0692 34.3925 44.2502 33.7318 44.25 33.0588V15.1301C44.2502 14.4571 44.0692 13.7964 43.7261 13.2175C43.383 12.6385 42.8904 12.1625 42.3 11.8395ZM24 6.95134L37.5 14.3445L33.4819 16.5438L19.9819 9.15259L24 6.95134ZM24 21.732L10.5 14.3445L15.2925 11.7195L28.7925 19.1088L24 21.732ZM8.25 18.2426L21.75 25.6301V40.0057L8.25 32.6145V18.2426ZM26.25 40.0057V25.6301L30.75 23.1682V28.5945C30.75 29.1912 30.9871 29.7635 31.409 30.1854C31.831 30.6074 32.4033 30.8445 33 30.8445C33.5967 30.8445 34.169 30.6074 34.591 30.1854C35.0129 29.7635 35.25 29.1912 35.25 28.5945V20.7045L39.75 18.2426V32.6145L26.25 40.0057Z",
    fill: "#012448",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/Package.7c1361c509412c4ae4e04338cabca5f3.svg";
export { ForwardRef as ReactComponent };